import HttpService from './http.service';
const getProductPagePartSelection = async ProductPagePartName => {
  var response = await HttpService.getAll(
    `ProductPagePartSelection?ProductPagePartName=${encodeURIComponent(
      ProductPagePartName
    )}`
  );
  return response.data;
};

export { getProductPagePartSelection };
